import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import InputArea from './InputArea';
import ConnectionState from './ConnectionState';

const ChatLayoutDesktop = ({ colors, header, authStatus, isReady, onRetry, messageListProps, inputProps }) => {
    return (
        <Flex
            position="fixed"
            inset="0"
            justifyContent="center"
            overflow="hidden"
            style={{ background: colors.chatBg }}
        >
            <Box
                w="960px"
                maxW="100%"
                h="100%"
                display="flex"
                flexDirection="column"
                overflow="hidden"
                position="relative"
                style={{ background: colors.chatBg, color: colors.textPrimary }}
            >
                <ChatHeader colors={colors} {...header} />

                {authStatus === 'error' && (
                    <ConnectionState variant="error" colors={colors} onRetry={onRetry} />
                )}

                {authStatus !== 'error' && !isReady && (
                    <ConnectionState variant="connecting" colors={colors} />
                )}

                {authStatus === 'authorized' && (
                    <>
                        {isReady && (
                            <Box flex={1} minH={0} overflow="hidden" display="flex" flexDirection="column">
                                <MessageList colors={colors} {...messageListProps} />
                            </Box>
                        )}
                        <Box px={3} pb={2}>
                            <InputArea colors={colors} {...inputProps} disabled={!isReady} />
                        </Box>
                    </>
                )}
            </Box>
        </Flex>
    );
};

export default ChatLayoutDesktop;
